/**
 * F4. Сезон на поле: три клетки, в каждой — одна из трёх культур с
 * честно написанными ожиданием и разбросом; при засухе — множители
 * по культурам. Посев — 30 % дохода, поровну на клетки.
 */
import { t } from '@life/i18n';
import { FIELD_DROUGHT_MULT, type CropIndex, type FieldInput, type FieldState } from '@life/minigames';
import { useState } from 'preact/hooks';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Field({ state, onInput }: MinigameScreenProps<FieldInput, FieldState>) {
  const [crops, setCrops] = useState<(CropIndex | null)[]>(() => Array.from({ length: state.cells }, () => null));
  const complete = crops.every((c) => c !== null);
  const [a, b, c] = FIELD_DROUGHT_MULT as [number, number, number];

  return (
    <>
      <p class="hint">{t('ui.minigame.field.stake', { sum: money(state.stake), cell: money(state.stake / state.cells) })}</p>
      {state.drought && <p class="hint">{t('ui.minigame.field.drought', { a, b, c })}</p>}
      {crops.map((picked, i) => (
        <div class="q" key={i} data-question={i}>
          <p class="q-text">{t('ui.minigame.field.cell', { n: i + 1 })}</p>
          <Choice
            label={t('ui.minigame.field.cell', { n: i + 1 })}
            items={state.crops.map((crop) => ({
              text: t(crop.key),
              note: t('ui.minigame.field.crop', { mean: Math.round(crop.mean * 100), sigma: Math.round(crop.sigma * 100) }),
            }))}
            value={picked}
            onChange={(j) => setCrops(crops.map((x, k) => (k === i ? (j as CropIndex) : x)))}
          />
        </div>
      ))}
      <button type="button" class="btn accent block" disabled={!complete} onClick={() => onInput({ crops: crops.map((x) => x ?? 0) })}>
        {t('ui.minigame.field.sow')}
      </button>
    </>
  );
}
